/// <amd-module name="CodeCoverage/CodeCoverageTab/Services/CodeCoverageTabProviderService" />
import { Build, BuildStatus } from "Build/Client/Contracts/Build";
import { IBuildResultsViewExtensionConfig } from "Build/Common/Library/ContributedExtension.types";
import { IRunDetailsService } from "Build/Run/RunDetailsService.types";
import { CodeCoverageSummary } from "Build/Run/RunExternalService";
import { BuildCodeCoverage, IBuildCodeCoverageProps } from "CodeCoverage/CodeCoverageTab/Components/BuildCodeCoverage";
import * as Resources from "CodeCoverage/CodeCoverageTab/Resources";
import { PerfScenarios, TelemetryEvents } from "CodeCoverage/Common/Constants";
import { RunViewArtifact } from "CodeCoverage/Common/RunViewArtifact";
import * as React from "react";
import { IReadonlyObservableValue } from "VSS/Core/Observable";
import { IVssContributableTabService } from "VSS/Features/Frame/IVssContributableTabService";
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IVssPerformanceService } from "VSS/Platform/Performance";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { IVssContributedPivotBarItem } from "VSSUI/Components/PivotBar/PivotBar.Props";

export class CodeCoverageTabProviderService extends VssService implements IVssContributableTabService {
    private _telemetryService: IVssTelemetryService;
    private _perfService: IVssPerformanceService;
    private codeCoverageTabEnabled: boolean = false;
    private codeCoverageResults: IReadonlyObservableValue<CodeCoverageSummary>;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._telemetryService = this.pageContext.getService<IVssTelemetryService>("IVssTelemetryService");
        this._perfService = this.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
    }

    public loadItems(updateItems: (items: IVssContributedPivotBarItem[]) => void, itemContext?: IBuildResultsViewExtensionConfig): void {
        if (itemContext) {
            itemContext.onBuildChanged((build: Build) => {
                const runViewArtifact = RunViewArtifact.GetArtifactDataFromBuild(build);
                this.onBuildChanged(runViewArtifact, updateItems);
            });
        } else {
            console.error("itemContext should've been present.");
        }
    }

    private onBuildChanged(runViewArtifact: RunViewArtifact, updateTabsCallback: (items: IVssContributedPivotBarItem[]) => void) {
        if (!this.codeCoverageTabEnabled && runViewArtifact.buildStatus == BuildStatus.Completed) {
            const runDetailsService = this.pageContext.getService<IRunDetailsService>("IRunDetailsService");
            this.codeCoverageResults = runDetailsService.codeCoverageResults;
            this.codeCoverageResults.subscribe(() => {
                this.createCodeCoverageTab (runViewArtifact, updateTabsCallback);
               });
            if (this.codeCoverageResults.value) {
                this.createCodeCoverageTab (runViewArtifact, updateTabsCallback);
            }   
           } 
    }
    
    private createCodeCoverageTab (runViewArtifact: RunViewArtifact, updateTabsCallback: (items: IVssContributedPivotBarItem[]) => void) {
        if (this.codeCoverageTabEnabled == false) {
            if (this.codeCoverageResults.value) {
                if ('coverage' in this.codeCoverageResults.value) {
                    if (this.codeCoverageResults.value.coverage) {
                        this.codeCoverageTabEnabled = true;
                        updateTabsCallback([
                            {
                                id: "codecoverage-tab",
                                render: () => {
                                    this._perfService.startScenario(PerfScenarios.CodeCoverageTab, true);
                                        return React.createElement(BuildCodeCoverage, { runViewArtifact: runViewArtifact } as IBuildCodeCoverageProps, null);
                                    },
                                    text: Resources.CodeCoverage,
                                    onBeforePivotChange: () => {
                                        this._telemetryService.publishEvent(TelemetryEvents.Area, TelemetryEvents.CodeCoverageTabClicked, {});
                                        return true;
                                    }
                            }
                        ]);
                    } 
                }
            }    
        }
        }
        
}

export var CodeCoverageTabProviderServiceName = "codecoverage-tab-provider-service";

Services.add(CodeCoverageTabProviderServiceName, { serviceFactory: CodeCoverageTabProviderService });
